/**
 * Setup Module
 *
 * Plain async functions that implement payment method setup flows
 * (e.g. Apple Merchant token enrollment). These are referenced by
 * the `performSetup` field in the gateway registry and called by
 * the `useSetupAction` shared hook.
 *
 * To add setup for a new kind:
 * 1. Create `performFooSetup.ts` in this folder
 * 2. Export it below
 * 3. Wire it in the registry entry: `performSetup: performFooSetup`
 */

export { performAppleMerchantSetup } from './performAppleMerchantSetup';
export { SetupCancelledError } from './errors';
